/* PosterLeFi kurv-drawer — rendering og handlinger.

   Tilvalg (ramme og premiumpapir) er EGNE varelinjer i Shopify, men skal vises
   indrykket under den plakat de hører til. De genkendes på de linje-properties
   produktsiden sætter: _frame_for / _for_product + _size.

   Butikken har ingen /cart-side; drawer'en er kurven. Alt går via /cart/change.js
   og /cart.js på det AKTIVE markeds rod-URL (et ikke-præfikset kald 302-redirecter
   og laver POST om til GET). */
(function () {
  'use strict';

  /* Temaet genrenderer header-sektionen naar kurven aendrer sig, saa noden
     bliver skiftet ud under os. Derfor slaas root og felter op PAA FORESPOERGSEL,
     og alle klik haandteres fra document. */
  function root() { return document.querySelector('[data-plf-cart]'); }
  if (!root()) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BASE = ROOT.replace(/\/$/, '');
  var T = {};
  function i18n() {
    var r = root();
    if (!r) return T;
    try { T = JSON.parse(r.dataset.i18n || '{}'); } catch (e) {}
    return T;
  }
  i18n();

  function $(sel) { var r = root(); return r ? r.querySelector(sel) : null; }
  var els = {
    get count() { return $('[data-plf-cart-count]'); },
    get body() { return $('[data-plf-cart-body]'); },
    get ship() { return $('[data-plf-ship]'); },
    get shipTxt() { return $('[data-plf-ship-text]'); },
    get shipBar() { return $('[data-plf-ship-bar]'); },
    get foot() { return $('[data-plf-cart-foot]'); }
  };

  /* ---- fri fragt: samme tærskel som resten af butikken ---- */
  function threshold() {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
    if (cur === 'DKK') return 39900;
    if (cur === 'EUR') return 4900;
    var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1');
    return Math.round(4900 * (isFinite(rate) && rate > 0 ? rate : 1));
  }

  /* ---- pengeformat afledt af Shopifys eget format, så valuta og
         skilletegn følger markedet ---- */
  function fmt() { var r = root(); return (r && r.dataset.money) || '{{amount}} kr'; }
  function money(cents) {
    var FMT = fmt();
    var dec = /amount_no_decimals/.test(FMT) ? 0 : 2;
    var comma = /comma_separator|amount_with_comma_separator|_comma/.test(FMT);
    var v = (cents / 100).toFixed(dec);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    var num = dec ? parts.join(comma ? ',' : '.') : parts[0];
    return FMT.replace(/\{\{\s*\w+\s*\}\}/, num).replace(/<[^>]*>/g, '').trim();
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function t(k, fallback) { return T[k] || fallback || ''; }

  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.5 2.5 4.5-5"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"><path d="M6 8h12l-1 12H7z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>'
  };

  /* ---- er linjen et tilvalg, og hvem hører den til? ---- */
  function addonOwner(item) {
    var p = item.properties || {};
    var owner = p._frame_for || p._for_product;
    if (!owner) return null;
    return { owner: String(owner), size: String(p._size || ''), kind: p._frame_for ? 'frame' : 'paper' };
  }
  function sizeOf(item) {
    var o = (item.options_with_values || []).filter(function (x) {
      return !/type|art|typ|rodzaj|tipo|tyyppi/i.test(x.name || '');
    })[0];
    return o ? String(o.value) : String(item.variant_title || '').split(' / ').pop();
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, ' ').trim(); }

  function group(items) {
    var parents = [], addons = [];
    items.forEach(function (it, i) {
      it.__line = i + 1;
      var a = addonOwner(it);
      if (a) { it.__addon = a; addons.push(it); } else { parents.push(it); }
    });
    parents.forEach(function (p) { p.__addons = []; });
    addons.forEach(function (ad) {
      var hit = parents.filter(function (p) {
        return norm(p.product_title) === norm(ad.__addon.owner)
          && (!ad.__addon.size || norm(sizeOf(p)) === norm(ad.__addon.size));
      })[0];
      if (hit) { hit.__addons.push(ad); } else { ad.__orphan = true; parents.push(ad); }
    });
    return parents;
  }

  /* Tilvalgets varenavn er raat fra Shopify ("Rammer - 50 x 70 cm / Eg Natur",
     "Premium papir 230 g/m² - 34" hvor 34 er prisniveauet). Det skal laeses som
     et tilvalg, ikke som et katalognavn. */
  function addonLabel(a) {
    if (a.__addon.kind === 'frame') {
      var parts = String(a.variant_title || '').split(' / ');
      var size = (parts[0] || '').replace(/\s*cm\s*$/, '').trim();
      var col = (parts[1] || '').trim();
      return t('frameLabel', 'Ramme') + (size ? ' ' + size : '') + (col ? ', ' + col.toLowerCase() : '');
    }
    return String(a.product_title || '').replace(/\s*[-·]\s*\d+\s*$/, '').trim();
  }

  /* ---- render ---- */
  function lineHtml(it) {
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    var vendor = it.vendor && it.vendor !== 'PosterLeFi' ? esc(it.vendor) + ' · ' : '';
    var meta = vendor + esc(String(it.variant_title || '').replace(' / ', ' '));
    var addons = (it.__addons || []).map(function (a) {
      var thumb = a.__addon.kind === 'frame' && a.image
        ? '<img src="' + esc(a.image.replace(/(\.[a-z]+)(\?|$)/i, '_60x$1$2')) + '" alt="">' : '';
      return '<div class="plf-cart__addon">' +
        '<span class="plf-cart__addon-name">' + thumb + '<span>' + esc(addonLabel(a)) + '</span></span>' +
        '<span class="plf-cart__addon-right"><b>' + money(a.final_line_price) + '</b>' +
        '<button type="button" class="plf-cart__remove" data-plf-del="' + a.__line + '" aria-label="' + esc(t('remove', 'Fjern')) + '">' + ICON.x + '</button>' +
        '</span></div>';
    }).join('');
    return '<div class="plf-cart__line">' +
      '<div class="plf-cart__line-main">' +
        (img ? '<img class="plf-cart__thumb" src="' + esc(img) + '" alt="" width="78" height="98">' : '<span class="plf-cart__thumb"></span>') +
        '<div class="plf-cart__line-txt">' +
          '<div class="plf-cart__line-top"><div style="min-width:0">' +
            '<div class="plf-cart__title">' + esc(it.product_title) + '</div>' +
            '<div class="plf-cart__meta">' + meta + '</div></div>' +
            '<button type="button" class="plf-cart__remove" data-plf-del="' + it.__line + '" aria-label="' + esc(t('remove', 'Fjern')) + '">' + ICON.x + '</button>' +
          '</div>' +
          '<div class="plf-cart__line-bot">' +
            '<div class="plf-cart__qty">' +
              '<button type="button" data-plf-qty="' + it.__line + '" data-d="-1"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-plf-qty="' + it.__line + '" data-d="1">+</button>' +
            '</div>' +
            '<span class="plf-cart__price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>' +
      (addons ? '<div class="plf-cart__addons"><div class="plf-cart__addons-label">' + esc(t('addons', 'Tilvalg')) + '</div>' + addons + '</div>' : '') +
    '</div>';
  }

  function emptyHtml() {
    return '<div class="plf-cart__empty">' + ICON.bag +
      '<b>' + esc(t('emptyTitle', 'Din kurv er tom')) + '</b>' +
      '<p>' + esc(t('emptyBody', '')) + '</p>' +
      '<a href="' + BASE + '/collections/all">' + esc(t('emptyCta', 'Shop alle plakater')) + '</a></div>';
  }

  /* Rabatkode-feltet er bevidst FJERNET: koden indløses alligevel i Shopifys
     egen checkout, og feltet stjal plads fra "Gå til betaling". */

  var FRAMES = null;
  function loadFrames() {
    if (FRAMES) return Promise.resolve(FRAMES);
    return fetch(BASE + '/products/frames.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { FRAMES = p; return p; })
      .catch(function () { return null; });
  }
  /* Krydssalg: foreslå en ramme i SAMME størrelse som en plakat der ikke
     allerede har en. Findes rammen ikke i den størrelse, vises intet. */
  function crossHtml(parents) {
    if (!FRAMES || !FRAMES.variants) return '';
    var target = parents.filter(function (p) {
      return !p.__orphan && !(p.__addons || []).some(function (a) { return a.__addon.kind === 'frame'; });
    })[0];
    if (!target) return '';
    var size = sizeOf(target);
    var v = FRAMES.variants.filter(function (x) {
      return norm(x.option1) === norm(size) && x.available && x.price > 0
        && /oak nature|eg natur|natureiche|ek natur|chêne naturel|roble natural|rovere naturale|dąb naturalny|eiken naturel|tammi/i.test(x.option2 || '');
    })[0];
    if (!v) return '';
    return '<div class="plf-cart__cross"><div class="plf-cart__cross-label">' +
      esc(t('often', 'Ofte valgt til').replace('{size}', size)) + '</div>' +
      '<div class="plf-cart__cross-row">' +
      (v.featured_image ? '<img src="' + esc(v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_92x$1$2')) + '" alt="">' : '<span></span>') +
      '<div class="plf-cart__cross-txt"><b>' + esc(v.title.replace(' / ', ', ')) + '</b>' +
      '<span>' + money(v.price) + '</span></div>' +
      '<button type="button" class="plf-cart__cross-add" data-plf-addframe="' + v.id + '" ' +
      'data-owner="' + esc(target.product_title) + '" data-size="' + esc(size) + '">' +
      esc(t('add', 'Tilføj')) + '</button></div></div>';
  }

  var LAST = null;
  function render(cart) {
    if (cart) LAST = cart;
    cart = cart || LAST;
    if (!cart || !root()) return;
    i18n();
    var head = $('[data-plf-cart-title]');
    if (head) head.textContent = t('title', 'Kurv');
    var parents = group(cart.items || []);
    var n = (cart.items || []).length ? cart.item_count : 0;
    els.count.textContent = n ? n + ' ' + (n === 1 ? t('one', 'vare') : t('many', 'varer')) : '';

    if (!parents.length) {
      els.body.innerHTML = emptyHtml() + footStatic();
      els.ship.hidden = true;
      els.foot.innerHTML = '<div class="plf-cart__foot-empty">' + esc(t('emptyFoot', '')) + '</div>';
      return;
    }
    els.ship.hidden = false;
    /* Krydssalget er fjernet efter oenske — det spiste pladsen fra varelisten. */
    els.body.innerHTML = parents.map(lineHtml).join('') + footStatic();

    var lim = threshold();
    var free = cart.total_price >= lim;
    els.ship.dataset.free = String(free);
    els.shipTxt.textContent = free
      ? t('shipFree', 'Du har fri fragt')
      : t('shipNeed', 'Køb for {x} mere og få fri fragt').replace('{x}', money(lim - cart.total_price));
    els.shipBar.style.width = Math.min(100, Math.round((cart.total_price / lim) * 100)) + '%';

    els.foot.innerHTML =
      '<div class="plf-cart__row"><span>' + esc(t('subtotal', 'Subtotal')) + '</span><span>' + money(cart.total_price) + '</span></div>' +
      '<div class="plf-cart__row plf-cart__row--ship"><span>' + esc(t('shipping', 'Fragt')) + '</span>' +
      '<b>' + esc(free ? t('free', 'Gratis') : t('calc', 'Beregnes')) + '</b></div>' +
      '<div class="plf-cart__total"><span>' + esc(t('total', 'Total')) + '</span><b>' + money(cart.total_price) + '</b></div>' +
      '<div class="plf-cart__tax">' + esc(t('tax', '')) + '</div>' +
      '<a class="plf-cart__checkout" href="' + BASE + '/checkout">' + esc(t('checkout', 'Gå til betaling')) + ' · ' + money(cart.total_price) + '</a>' +
      '<button type="button" class="plf-cart__continue" data-plf-continue>' + esc(t('continue', 'Fortsæt med at handle')) + '</button>';
    els.foot.classList.toggle('plf-cart__ship-free', free);
  }

  /* USP'er, betalings- og fragtikoner er ens uanset kurvens indhold.
     Ikonerne kommer fra <template>-noderne, som Liquid har fyldt med
     shop.enabled_payment_types — så listen er altid butikkens rigtige. */
  function footStatic() {
    var pay = $('template[data-plf-pay]');
    var car = $('template[data-plf-carriers]');
    /* u3 ("Trykt efter bestilling") er bevidst UDELADT: kurven skal kun have
       ÉN raekke KPI'er, og tre punkter er det der kan staa paa én linje i
       drawer'ens ~356 px. Teksterne selv ligger stadig i i18n-blokken. */
    return '<div class="plf-cart__usp">' +
      [1, 2, 4].map(function (i) {
        return '<span>' + ICON.check + esc(t('u' + i, '')) + '</span>';
      }).join('') + '</div>' +
      '<div class="plf-cart__paylabel">' + esc(t('payWith', '')) + '</div>' +
      '<div class="plf-cart__pay">' + (pay ? pay.innerHTML : '') + '</div>' +
      '<div class="plf-cart__paylabel">' + esc(t('shipWith', '')) + '</div>' +
      '<div class="plf-cart__carriers">' + (car ? car.innerHTML : '') + '</div>';
  }

  /* ---- data ---- */
  function load() {
    return Promise.all([
      fetch(BASE + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      loadFrames()
    ]).then(function (res) {
      render(res[0]);
      syncBadges(res[0]);
      return res[0];
    }).catch(function () {});
  }
  function syncBadges(cart) {
    document.querySelectorAll('[data-cart-count],[data-sidecart-count]').forEach(function (el) {
      el.textContent = String(cart.item_count);
      if (el.dataset.cartCount !== undefined) el.dataset.cartCount = String(cart.item_count);
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }
  function change(line, qty) {
    var r0 = root(); if (r0) r0.setAttribute('aria-busy', 'true');
    return fetch(BASE + '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncBadges(cart); })
      .catch(function () {})
      .then(function () { var r1 = root(); if (r1) r1.removeAttribute('aria-busy'); });
  }

  /* ---- klik ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-plf-cart]')) {
      if (!e.target.closest || !e.target.closest('[data-plf-qty],[data-plf-del],[data-plf-addframe],[data-plf-continue],[data-plf-cart-close]')) return;
    }
    var q = e.target.closest('[data-plf-qty]');
    if (q) {
      var line = +q.dataset.plfQty;
      var cur = +q.parentElement.querySelector('span').textContent || 1;
      change(line, Math.max(0, cur + (+q.dataset.d)));
      return;
    }
    var d = e.target.closest('[data-plf-del]');
    if (d) { change(+d.dataset.plfDel, 0); return; }
    var f = e.target.closest('[data-plf-addframe]');
    if (f) {
      f.disabled = true;
      fetch(BASE + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +f.dataset.plfAddframe, quantity: 1,
          properties: { '_frame_for': f.dataset.owner, '_size': f.dataset.size } }] })
      }).then(function () { return load(); }).then(function () { f.disabled = false; });
      return;
    }
    if (e.target.closest('[data-plf-continue],[data-plf-cart-close]')) {
      var closer = document.getElementById('mobileDrawerClose')
        || document.querySelector('.cart-favorite__mobile-close');
      if (closer) closer.click();
      else document.documentElement.classList.remove('cart-open');
    }
  });

  /* ---- hold i sync med resten af butikken ---- */
  document.addEventListener('cart:updated', load);
  /* fetch skal kaldes MED window som modtager. Filen koerer i strict mode, saa
     et bart fetch(...) giver this === undefined, og .apply(this) kastede
     "Illegal invocation" — det fik produktsidens laeg-i-kurv til at falde i sit
     catch og submitte formularen, saa browseren hoppede til /cart/add. */
  /* Kurven ÅBNER ved læg-i-kurv, så kunden kan se at varen kom med — og
     derfra enten gå til betaling, lukke, eller handle videre. Temaets egen
     bekræftelses-popup tegner intet synligt, så uden det her fik kunden slet
     ingen kvittering.
     Produktsiden lægger plakat + ramme + papir som TRE separate kald, så
     åbningen debounces og sker først når den sidste er landet. */
  var openTimer = null;
  function drawerOpen() {
    var d = document.querySelector('.cart-favorite');
    if (!d) return false;
    var s = window.getComputedStyle(d);
    return s.display !== 'none' && s.visibility !== 'hidden' && d.getBoundingClientRect().width > 10;
  }
  function openDrawerSoon() {
    if (openTimer) window.clearTimeout(openTimer);
    openTimer = window.setTimeout(function () {
      openTimer = null;
      if (drawerOpen()) return;
      var btn = document.querySelector('.header-cart-icon');
      if (btn) btn.click();          /* temaets egen sti — al dens state kører med */
    }, 400);
  }

  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var out = origFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
        var isAdd = /\/cart\/add(\.js)?/.test(url);
        out.then(function (r) {
          if (!r || !r.ok) return;
          window.setTimeout(load, 80);
          if (isAdd) openDrawerSoon();
        }).catch(function () {});
      }
    } catch (e) {}
    return out;
  };

  /* Naar temaet skifter header-noden ud, staar den nye drawer tom — tegn den
     igen med det samme i stedet for at lade brugeren se en tom kurv. */
  if ('MutationObserver' in window) {
    var seen = root();
    new MutationObserver(function () {
      var now = root();
      if (now && now !== seen) { seen = now; i18n(); render(LAST) || load(); }
      else if (now && !now.querySelector('.plf-cart__line, .plf-cart__empty')) { render(LAST); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  load();
})();
